export const apiPath = process.env.NODE_ENV === "development"
    ? process.env.API_PROXY_PREFIX
    : process.env.API_URL;
